export const MAIN_MENU = [
  {
    id: "id-menu-home",
    title: "Home",
    url: "/#splash",
  },
  {
    id: "id-menu-offer",
    title: "What we offer",
    url: "/#what-we-offer",
  },
  {
    id: "id-menu-our-work",
    title: "Our work",
    url: "/#our-work",
  },
  {
    id: "id-menu-our-team",
    title: "Our team",
    url: "/#our-team",
  },
  {
    id: "id-menu-mission",
    title: "Mission",
    url: "/#mission",
  },
  {
    id: "id-menu-testimonials",
    title: "Testimonials",
    url: "/#our-saying",
  },
  {
    id: "id-menu-contact",
    title: "Contact",
    url: "/#contact-us",
  },
  {
    id: "research",
    title: "Research",
    url: "/research",
  },
  {
    id: "blog",
    title: "Blog",
    url: "http://blog.joviantechnologies.io",
  }
];

export const FOOTER_MENU = [
  {
    label: "Home",
    targetId: "",
  },
  {
    label: "What we offer",
    targetId: "",
  },
  {
    label: "Our work",
    targetId: "",
  },
  {
    label: "Our team",
    targetId: "",
  },
  {
    label: "Testimonials",
    targetId: "",
  },
  {
    label: "Contact us",
    targetId: "",
  },
];

export const PERCENTAGE = [
  {
    amount: "99",
    symbol: "%",
    desc: "Happy Clients",
  },
  {
    amount: "100",
    symbol: "+",
    desc: "Applications completed",
  },
  {
    amount: "12",
    symbol: "+",
    desc: "Year of experience",
  },
  {
    amount: "6",
    symbol: "+",
    desc: "People team",
  },
];
